<div class="logo">
  <img
    [ngSrc]="darkTheme() ? environment().branding.logoSmall : environment().branding.logoSmall.replace('-white', '')"
    [priority]="true" alt="clearML" class="logo-a" width="64" height="64">
</div>

@if (currentUser()) {
  <nav #container class="items-container" [class.on-scrolling]="scrolling()" aria-label="Main navigation">
    <a class="item al-ico-home" routerLink="/dashboard" routerLinkActive="active"
       [routerLinkActiveOptions]="sectionMatch" smTooltip="MISSION CONTROL" aria-label="Mission Control"></a>
    <a class="item al-ico-projects" [routerLink]="experimentsRoute()" [class.active]="baseRouteConfig() === 'projects'"
       smTooltip="EXPERIMENTS" aria-label="Experiments"></a>
    @if (rolloutViewer(); as url) {
      <a class="item al-ico-reports" [href]="url" target="_blank" rel="noopener noreferrer"
         smTooltip="ROLLOUTS" aria-label="View rollouts"></a>
    }
    <a class="item al-ico-queues" routerLink="/workers-and-queues" routerLinkActive="active"
       smTooltip="WORKERS & QUEUES" aria-label="Workers and queues"></a>
  </nav>
}
